<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备件类型" prop="bpbjType">
              <j-dict-select-tag dictCode="bpbj_type" type="radioButton" v-model="model.bpbjType" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :rules="[{required:model.bpbjType==2,message: '设备类型不能为空',trigger:'blur'}]"
              :wrapperCol="wrapperCol"
              label="适配设备类型"
              prop="devClassCode"
            >
              <j-tree-select-custom
                @change="handleModeQuery"
                column="dev_class_code"
                dict="`iwt-wf`.dev_class,type_name,id"
                hasChildField="has_child"
                pidValue="-1"
                placeholder="请选择设备类型"
                ref="treeSelect"
                returnKey="dev_class_code"
                v-model="model.devClassCode"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备件名称" prop="bjName">
              <a-input placeholder="请输入备件名称" v-model="model.bjName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :rules="[{required:model.bpbjType==2,message: '设备型号不能为空',trigger:'blur'}]"
              :wrapperCol="wrapperCol"
              label="适配设备型号"
              prop="devModeId"
            >
              <a-select
                :default-active-first-option="false"
                @change="modelChange"
                allowClear
                defaultActiveFirstOption
                mode="multiple"
                placeholder="请选择设备型号"
                show-search
                v-model="model.devModeId"
              >
                <a-select-option :key="d.id" v-for="d in devModelList">{{ d.modelName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备件型号" prop="bjModel">
              <a-input placeholder="请输入备件型号" v-model="model.bjModel"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备件型号规格" prop="bjModelSpec">
              <a-input placeholder="请输入备件型号规格" v-model="model.bjModelSpec"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产厂家" prop="manuId">
              <j-select-device-facturer
                :multiple="false"
                @select="manuSelected"
                placeholder="请选择生产厂家"
                v-model="model.manuId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单位" prop="unit">
              <a-input placeholder="请输入计量单位" v-model="model.unit"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'DevBpbjStandardInfoForm',
    components: {
    },
    props: {
      // 表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
          bpbjType: '2'
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {
          bjName: [{ required: true, message: '请输入备件名称!' }],
          bjModel: [{ required: true, message: '请选择备件型号!' }],
          bpbjType: [{ required: true, message: '请选择备件类型!' }]
        },
        devClassList: [],
        devModelList: [],
        url: {
          add: '/spareparts/devBpbjStandardInfo/add',
          edit: '/spareparts/devBpbjStandardInfo/edit',
          queryById: '/spareparts/devBpbjStandardInfo/queryById',
          selectClass: '/device/devClass/selectDropList'
        },
        manuList: []
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      }
    },
    watch: {
      'model.bpbjType': function (val) {
        if (val && val === '2') {
          this.$refs.form.clearValidate('receiver')

        }
      }
    },
    async created () {
      // const manuList = await getAction('/device/commonManufacturer/selectDropList', '')

      //  this.manuList = manuList.result.records
      // const devModelList = await getAction('/device/devModel/selectDropList', '')

      // this.devModelList = devModelList.result.records
      /// device/devModel/selectDropList

      // 备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))
      // this.getClassList()
    },
    methods: {
      async handleModeQuery (v) {
        if (this.model.devModeId) this.model.devModeId = []
        this.devModelList = []
        const { success, result } = await getAction('/device/devModel/queryByDevClassId', {
          devClassCode: v
        })
        if (success) {
          this.devModelList = result
        }
      },
      modelChange (v) {
        if (v === undefined) this.model.devModeId = ''
      },
      add () {
        this.edit(this.modelDefault)
      },
      edit (record) {
        this.model = Object.assign({}, record)
        if (record.devClassCode) {
          this.handleModeQuery(record.devClassCode)
        }
        this.visible = true
      },
      manuSelected (record) {
        this.model.manuName = record[0].manuName
      },

      submitForm () {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'put'
            }

            httpAction(httpurl, { ...this.model, devModeId: this.model?.devModeId?.join() ?? '' }, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.confirmLoading = false
            })
          }
        })
      },
      getClassList () {
        getAction(this.url.selectClass, {}).then(res => {
          this.devClassList = res.result.records.map(item => {
            return {
              value: item.id,
              label: item.typeName
            }
          })
        })
      },
      modelChange (e) {

      }
    }
  }
</script>
